function _loginClicked(lfolder,hId,L_Error1,L_Error2,selectedLang,ta_flag,ta_error,blockedUser,guest_flag,guest_error)
{
	try
	{
	var getUrl=serverurl+'login-'+hId;
	var setLang='';
	if(selectedLang!='' && selectedLang!=null)
	{
		setLang=selectedLang;
	}

/*XSS and CSRF changes - Chinmay - START*/
	var config_token=jQuery("input#restoken").val();
	if(typeof(config_token)=='undefined') {
       var config_token='';
    }
	jQuery.ajax({
		  type: "POST",		
		  url: serverurl+'service.php',			  
		  data: 'action=checktoken&HotelId='+hId+'&config_token='+config_token,
		  success: function(response) {
			  
		   },//success
		   complete: function(response){
			console.log("token response " + response.responseText + " : " + config_token);
			if (jQuery.trim(response.responseText)==1 || config_token=='') {						
/*XSS and CSRF changes - Chinmay - END*/
	
	$.ajax({
		url: getUrl,
		type: "POST",
		data: {
			username: $("#username").val(),
			password: $("#password").val(),
			action: 'CheckUserExists'
		},
		error: function(){
		},
		beforeSend: function(){
		},
		complete: function(){
		},
		success: function( response ){
			var resultStatus=$.trim(response);
			var resdata=resultStatus.split("-");
					
					if(resdata[0]=='LoginEmpty'){
						_setMessages(L_Error1,resdata[0]);
					}
					else if(resdata[0]=='LoginInValid'){
						_setMessages(L_Error2,resdata[0]);
					}
					//Chinmay Gandhi - 1.0.52.60 - Change encript type - Start
					else if(resdata[0]=='TravelAgent' && ta_flag==0 && resdata[2]!=''){
						if(resdata[2] == '1')
						{
							window.location.href='book-rooms-'+lfolder+'-lt'+setLang;
						}
						else if(resdata[2] == '0')
						{
							jQuery(".LoginForm").hide();
							jQuery("#ResetPWS").show();
							jQuery("#RebackAction").val('11');
						}
					}
					//Chinmay Gandhi - 1.0.52.60 - Change encript type - End
					else if(resdata[0]=='TravelAgent' && ta_flag==1){	//added flora
						_setMessages(ta_error,'LoginInValid');
					}
					else if(resdata[0]=='Guest' && guest_flag==1){
						_setMessages(guest_error,'LoginInValid');
					}
					//Chinmay Gandhi - 1.0.52.60 - Change encript type - Start
					else if(resdata[0]=='Guest' && resdata[2]!=''){
						if(resdata[2] == '1')
						{
							window.location.href='myaccount-'+lfolder+setLang;
						}
						else if(resdata[2] == '0')
						{
							jQuery(".LoginForm").hide();
							jQuery("#ResetPWS").show();
							jQuery("#RebackAction").val('22');
						}
					}
					//Chinmay Gandhi - 1.0.52.60 - Change encript type - End
					//Chirag 21 oct 2020 - RES-2626 - START
					else if(resdata[0]=='Blocked')
					{
						_setMessages(blockedUser,resdata[0]);
					}
					//Chirag 21 oct 2020 - RES-2626 - END
					else{
						window.location.href='book-rooms-'+lfolder+setLang;
					}
				}
			});
	
	/*XSS and CSRF changes - Chinmay - START*/			
		}
		else
		{
			_setMessages("Invalid Request",'InvalidDetails');
			return false;
		}
		}
		});//Main
	/*XSS and CSRF changes - Chinmay - END*/	
	
   }
   catch(err){
		console.log("Error - _loginClicked - "+err.message);
   }
}
//Chinmay Gandhi - 1.0.52.60 - Change encript type - Start
//Purpose: Reset Password
function _ResetAction(newpwd,hotelcode,RebackAction,lfolder,selectedLang)
{
	try
	{
		var setLang='';
		if(selectedLang!='' && selectedLang!=null)
		{
			setLang=selectedLang;
		}
		var getUrl=serverurl+'login-'+hotelcode;
		$.ajax({
			url: getUrl,
			type: "POST",
			data: {
				NewPass: newpwd,
				action: 'ResetPassword'
			},
			success: function(response){
				var response_data = jQuery.trim(response);
				if((response_data == 'PasswordUpdate') && (RebackAction == 11))
				{
					window.location.href='book-rooms-'+lfolder+'-lt'+setLang;
				}
				else if((response_data == 'PasswordUpdate') && (RebackAction == 22))
				{
					window.location.href='myaccount-'+lfolder+setLang;
				}
			}
		});
	}
	catch(err){
		 console.log("Error - _ResetAction - "+err.message);
	}
}
//Chinmay Gandhi - 1.0.52.60 - Change encript type - End

function _CancelBookingProcess(hId,L_Error1,selectedLang)
{
	try
	{
		/*XSS and CSRF changes - Chinmay - START*/
			var config_token=jQuery("input#restoken").val();
			if(typeof(config_token)=='undefined') {
			   var config_token='';
			}
			jQuery.ajax({
				  type: "POST",
				  url: serverurl+'service.php',			  
				  data: 'action=checktoken&HotelId='+hId+'&config_token='+config_token,
				  success: function(response) {
					  
				   },//success
				   complete: function(response){
					console.log("token response " + response.responseText + " : " + config_token);
					if (jQuery.trim(response.responseText)==1 || config_token=='') {						
		/*XSS and CSRF changes - Chinmay - END*/
						getUrl=serverurl+'cancelbooking-'+hId;
						var setLang='';
						if(selectedLang!='' && selectedLang!=null)
						{
							setLang=selectedLang;
						}
						var resno=$("#resno").val();
						
						$.ajax({
							url: getUrl,
							type: "POST",
							data: {
								resno: $("#resno").val(),
								email: $("#email").val(),
								action: 'CheckNumberExists'
							},
							error: function(){
							},
							beforeSend: function(){
							},
							complete: function(){
							},
							success: function( response ){
									
								var resultStatus=$.trim(response);
								if(resultStatus=='InvalidDetails')
										_setMessages(L_Error1,resultStatus);			
								else
								{
									document.cancelfrm.action='cancelbookinglist-'+hId+setLang;
									document.cancelfrm.submit();
								}
							}	
						});
		/*XSS and CSRF changes - Chinmay - START*/			
					}
					else
					{
						_setMessages("Invalid Request",'InvalidDetails');
						return false;
					}
				}
			});//Main
		/*XSS and CSRF changes - Chinmay - END*/	
   }
   catch(err){
		console.log("Error - _CancelBookingProcess - "+err.message);
   }
}
function _setMessages(_mxgTxt,_msgtype)
{
	$("#statusMsg").removeClass('error');
	$("#statusMsg").removeClass('common_error');
	if(_msgtype=='LoginInValid' || _msgtype=='InvalidDetails')
	{
		$("#statusMsg").html(js_stripslashes(_mxgTxt)).removeClass('error').removeClass('common_error').addClass('error common_error').fadeIn(500).delay(3500).fadeOut(500);		
	}
	else if(_msgtype=='ProfileUpdate' || _msgtype=='CancelSuccess')
		jQuery("#statusMsg").html(js_stripslashes(_mxgTxt)).removeClass('success').addClass('success').fadeIn(500).delay(1500).fadeOut(500);
	else if(_msgtype=='ProfileError')
		jQuery("#statusMsg").html(js_stripslashes(_mxgTxt)).removeClass('valerror').addClass('valerror error common_error').fadeIn(500).delay(1500).fadeOut(500);
	else if(_msgtype=='PasswordUpdate')
		jQuery("#statusMsg").html(js_stripslashes(_mxgTxt)).removeClass('success').addClass('success').fadeIn(500).delay(1500).fadeOut(500);
	else if(_msgtype=='PasswordNotMatch')
		jQuery("#statusMsg").html(js_stripslashes(_mxgTxt)).removeClass('valerror').addClass('valerror error common_error').fadeIn(500).delay(1500).fadeOut(500);
	else if(_msgtype=='PasswordError')
		jQuery("#statusMsg").html(js_stripslashes(_mxgTxt)).removeClass('valerror').addClass('valerror error common_error').fadeIn(500).delay(1500).fadeOut(500);
	/*Chirag RES-2566 -START*/
	else if(_msgtype=='PE')
		jQuery("#statusMsg").html(js_stripslashes(_mxgTxt)).removeClass('valerror').addClass('valerror error common_error').fadeIn(500).delay(3500).fadeOut(500);
	/*Chirag - END*/
	else if(_msgtype=='Blocked') /*Chirag RES-2626 */
		jQuery("#statusMsg").html(js_stripslashes(_mxgTxt)).removeClass('valerror').addClass('valerror error common_error').fadeIn(500).delay(3500).fadeOut(500);
}

function _getPageData(pagename,datafrom,datato,hId,selectedLang,lfolder)
{
	var setLang='';
	if(selectedLang!='' && selectedLang!=null)
	{
		setLang=selectedLang;
	}
	getUrl=serverurl+pagename+'-'+hId+setLang;
    showLoadingBar();
	jQuery.ajax({
	url: getUrl,
	type: "POST",
	data: {
			setLayout: 'plugin'
		},
	error: function(){
	},
	beforeSend: function(){		
		jQuery('#_disPageData').html('');
		jQuery('#_disPageData').show();
		if(datafrom=='#_profileInfo')
		{
			jQuery('#_getProfile').addClass('linkselected');
			jQuery('#_getChPassword').removeClass('linkselected');
			jQuery('#_disPageData').removeClass('chpass');
			jQuery('#_disPageData').addClass('editprof'); //Chaitali - 1.0.38.43 - 27 Jan 2014
		}
		if(datafrom=='#_PasswordInfo')
		{
			jQuery('#_getProfile').removeClass('linkselected');
			jQuery('#_getChPassword').addClass('linkselected');
			jQuery('#_disPageData').addClass('chpass');	
			jQuery('#_disPageData').removeClass('editprof'); //Chaitali - 1.0.38.43 - 27 Jan 2014
		}
	},
	complete: function(){		
		jQuery('select.combobox').selectmenu();
		 hideLoadingBar();
	},
	success: function( response ){
		$("<div id='temp' style='display:block;'></div>").appendTo("div"+datato);
		$("#temp").html(response);
		$(datato).append($(datafrom).html());
		$("#temp").remove();
		bklisturl=serverurl+'reservationlist-'+lfolder+setLang;
		if(datafrom!='#_profileInfo' && datafrom!='#_PasswordInfo') {
			console.log(response.indexOf("total_0"));
			if (response.indexOf("total_0") == -1) 
			{
				$(datato).append('<a href="'+bklisturl+'" class="morebookings">More Bookings</a>');
			}
		}
		}	
	});	
}

function _editProfile(hId,L_ProfileUpdate,L_ProfileError,selectedLang)
{
	try
	{
		getUrl=serverurl+'profileupdt-'+hId;
		var setLang='';
		if(selectedLang!='' && selectedLang!=null)
		{
			setLang=selectedLang;
		}
		/*XSS and CSRF changes - Chinmay - START*/
			var config_token=jQuery("input#restoken").val();
			if(typeof(config_token)=='undefined') {
			   var config_token='';
			}
			jQuery.ajax({
				  type: "POST",		
				  url: serverurl+'service.php',			  
				  data: 'action=checktoken&HotelId='+hId+'&config_token='+config_token,
				  success: function(response) {
					  
				   },//success
				   complete: function(response){
					console.log("token response " + response.responseText + " : " + config_token);
					if (jQuery.trim(response.responseText)==1 || config_token=='') {						
		/*XSS and CSRF changes - Chinmay - END*/
			showLoadingBar();
			jQuery.ajax({
				url: getUrl,
				type: "POST",
				data: {
					title: jQuery("#title").val(),
					guestname: jQuery("#guestname").val(),
					address: jQuery("#address").val(),
					city: jQuery("#city").val(),				
					state: jQuery("#state").val(),
					zip: jQuery("#zip").val(),
					country: jQuery("#country").val(),
					phone: jQuery("#phone").val(),
					mobile: jQuery("#mobile").val(),
					fax: jQuery("#fax").val(),
					mlandcode: jQuery("#mlandcode").val(),
					action: 'EditProfile'
				},
				error: function(){
				},
				beforeSend: function(){
				},
				complete: function(){
					hideLoadingBar();
				},
				success: function( response ){
					var resultStatus=jQuery.trim(response);
					if(resultStatus=='ProfileUpdate')
						_setMessages(L_ProfileUpdate,resultStatus);
					else if(resultStatus=='ProfileError')
						_setMessages(L_ProfileError,resultStatus);	
					else if(resultStatus=='')
						_setMessages(L_ProfileError,"ProfileError");
					
					setTimeout(function () {window.location.reload()}, 1000);
				}
			});
		/*XSS and CSRF changes - Chinmay - START*/			
					}
					else
					{
						_setMessages("Invalid Request",'InvalidDetails');
						return false;
					}
				}
			});//Main
		/*XSS and CSRF changes - Chinmay - END*/
   }
   catch(err){
		console.log("Error - _editProfile - "+err.message);
   }
}

function _PasswordUpdate(hId,L_PasswordUpdate,L_PasswordError,L_PasswordNotMatch,selectedLang,PE) /*Chirag Added PE*/
{
	try
	{
		
		getUrl=serverurl+'passwordupdt-'+hId;
		var setLang='';
		if(selectedLang!='' && selectedLang!=null)
		{
			setLang=selectedLang;
		}
		
		/*XSS and CSRF changes - Chinmay - START*/
			var config_token=jQuery("input#restoken").val();
			if(typeof(config_token)=='undefined') {
			   var config_token='';
			}
			jQuery.ajax({
				  type: "POST",		
				  url: serverurl+'service.php',			  
				  data: 'action=checktoken&HotelId='+hId+'&config_token='+config_token,
				  success: function(response) {
					  
				   },//success
				   complete: function(response){
					console.log("token response " + response.responseText + " : " + config_token);
					if (jQuery.trim(response.responseText)==1 || config_token=='') {						
		/*XSS and CSRF changes - Chinmay - END*/
				
				showLoadingBar();
				jQuery.ajax({
					url: getUrl,
					type: "POST",
					data: {
						oldpassword: jQuery("#oldpassword").val(),
						newpassword: jQuery("#newpassword").val(),			
						action: 'EditPassword'
					},
					error: function(){
					},
					beforeSend: function(){
					},
					complete: function(){
						hideLoadingBar();
					},
					success: function( response ){
						var resultStatus=jQuery.trim(response);
						if(resultStatus=='PasswordUpdate') {
							_setMessages(L_PasswordUpdate,resultStatus);
							setTimeout(function () {window.location.reload()}, 1000);
						}
						else if(resultStatus=='PasswordNotMatch')
							_setMessages(L_PasswordNotMatch,resultStatus);			
						else if(resultStatus=='PasswordError')
							_setMessages(L_PasswordError,resultStatus);	
						else if(resultStatus=='')
							_setMessages(L_PasswordError,"PasswordError");
						else if(resultStatus=='PE') /*Chirag - RES-2566 */
							_setMessages(PE,"PE");
						
					}
				});
		/*XSS and CSRF changes - Chinmay - START*/			
					}
					else
					{
						_setMessages("Invalid Request",'InvalidDetails');
						return false;
					}
				}
			});//Main
		/*XSS and CSRF changes - Chinmay - END*/
	}
   catch(err){
		console.log("Error - _PasswordUpdate - "+err.message);
   }
}

function _searchReservation(lfolder,hId,selectedLang)
{	
	var setLang='';
	if(selectedLang!='' && selectedLang!=null)
	{
		setLang=selectedLang;
	}
		/*XSS and CSRF changes - Chinmay - START*/
			var config_token=jQuery("input#restoken").val();
			if(typeof(config_token)=='undefined') {
			   var config_token='';
			}
			jQuery.ajax({
				  type: "POST",		
				  url: serverurl+'service.php',			  
				  data: 'action=checktoken&HotelId='+hId+'&config_token='+config_token,
				  success: function(response) {
					  
				   },//success
				   complete: function(response){
					console.log("token response " + response.responseText + " : " + config_token);
					if (jQuery.trim(response.responseText)==1 || config_token=='') {						
		/*XSS and CSRF changes - Chinmay - END*/
					getUrl=serverurl+'reservationlist-'+lfolder+setLang+'-search-0';
					
					document.bookinglistfrm.action=getUrl;
					document.bookinglistfrm.submit();
		/*XSS and CSRF changes - Chinmay - START*/			
					}
					else
					{
						_setMessages("Invalid Request",'InvalidDetails');
						return false;
					}
				}
			});//Main
		/*XSS and CSRF changes - Chinmay - END*/
}

function _resetReservation(lfolder,hId,arrivalfrom,arrivalto,selectedLang)
{
	var setLang='';
	if(selectedLang!='' && selectedLang!=null)
	{
		setLang=selectedLang;
	}
	
	/*XSS and CSRF changes - Chinmay - START*/
		var config_token=jQuery("input#restoken").val();
		if(typeof(config_token)=='undefined') {
		   var config_token='';
		}
		jQuery.ajax({
			  type: "POST",		
			  url: serverurl+'service.php',			  
			  data: 'action=checktoken&HotelId='+hId+'&config_token='+config_token,
			  success: function(response) {
				  
			   },//success
			   complete: function(response){
				console.log("token response " + response.responseText + " : " + config_token);
				if (jQuery.trim(response.responseText)==1 || config_token=='') {						
	/*XSS and CSRF changes - Chinmay - END*/
	
		jQuery("#txtResNo").val('');
		jQuery("#cmbRoomType").val('');	
		jQuery("#cmbStatus").val('ACTIVE');
		jQuery("#cmbResType").val('');
		jQuery("#chkArrival").attr('checked','true');	
		jQuery("#txtFrom").val(arrivalfrom);
		jQuery("#txtTo").val(arrivalto);
		
		jQuery('input:radio[name=chkdate]').attr('checked',false);
		jQuery('input:radio[name=chkdate]:nth(0)').attr('checked',true);
		
		getUrl=serverurl+'reservationlist-'+lfolder+setLang+'-reset-0';
		
		document.bookinglistfrm.action=getUrl;
		document.bookinglistfrm.submit();
	/*XSS and CSRF changes - Chinmay - START*/			
					}
					else
					{
						_setMessages("Invalid Request",'InvalidDetails');
						return false;
					}
				}
			});//Main
	/*XSS and CSRF changes - Chinmay - END*/
}

$(function(){
 
});